define('SageDotCom/Components/ProductCardAlignment',[
    "jquery",
    "eventManager",
    "slick"
], function ($, eventManager, slick) {
    function ProductCardAlignment() { }

    ProductCardAlignment.prototype.init = function init() {
        var that = this;

        this.productCardLogic();

        eventManager.subscribe("product card refresh heights", function ($el) {
            setTimeout(function () {
                if (that.shouldProductCardsResize($el)) {
                    that.refreshProductCardHeights();
                }
            }, 50);
        });

        var timeoutSS;
        var saveWidthSS = $(window).width();
        $(window).resize(function () {
            if (saveWidthSS !== $(window).width()) {
                saveWidthSS = $(window).width();
                clearTimeout(timeoutSS);
                timeoutSS = setTimeout(function () {
                    that.refreshProductCardHeights();
                }, 1000);
            }
        });
    }

    ProductCardAlignment.prototype.setHeightsForInnerElements = function (grouped) {
        var that = this;
        $(grouped).each(function (t, sameTop) {
            var elems = that.getInsideElements(sameTop);
            that.setHeightForTable(elems, "product-card-inner-height-auto-set");
        });
    };

    ProductCardAlignment.prototype.productCardLogic = function () {
        //product card
        $(".sage-product-card:not(.experience-editor)").each(function () {
            $(this).children(":not(.sage-product-card-promo-header)").wrapAll("<div class='sage-product-card-wrapper'></div>");
            $(this).find(".sage-product-card-content").wrapAll("<div class='sage-product-card-body'></div>");
        });
        ////product card alt
        $(".sage-product-card-alt:not(.experience-editor)").each(function () {
            $(this).children(":not(.sage-product-card-promo-header-alt)").wrapAll("<div class='sage-product-card-wrapper-alt'></div>");
        });

        //for 3 to 1 aspect ratio, wrap all but first card into a single div
        $(".score-flex-box.aspect-ratio-one-three").each(function () {
            $(this).children(".flex-item:not(:first)").wrapAll("<div class='sage-product-card-ratio-container'><div class='sage-product-card-scroller'></div></div>");
        });
        

        this.adjustProductCardHeight();
    };

    ProductCardAlignment.prototype.adjustProductCardHeight = function () {

        //adjust height on elements inside the body
        var productCardGroupedSameTop = this.getProductCardSameTop();

        //remove the inner body elements
        $(".sage-product-card-body").find(".sage-product-card-content").children().unwrap();
        $(".sage-product-card-body").addClass("sage-product-card-content");

        if (productCardGroupedSameTop != null && productCardGroupedSameTop.length > 0) {
            //gropup similar elements, like buttons
            this.performWrappingOfSimilarElements(productCardGroupedSameTop);

            //set heights for the inner elements
            this.setHeightsForInnerElements(productCardGroupedSameTop);

            //set height of buttons in the same top
            this.setButtonsHeightInProductCards(productCardGroupedSameTop);
        }

        //match height on the containers //twice(!!!required) as the logic in between reposition the elements
        this.sageProductCardMatchHeight();
    };

    var getResizeScopesForResolution = function () {
        var windowWidth = $(window).width();

        var isSlick = $(".slick-cards") !== null && $(".slick-cards").length > 0;
        isSlick = isSlick || ($(".slicked-table") !== null && $(".slicked-table").length > 0);
        
        var baseSelector = "";
        if (windowWidth < 768) {
            if (!isSlick) {
                return [];
            }
        }
        else if (windowWidth < 1080) {
            //Tablet - only match the first two that match
            //One three - the three are in a carousel together
            //One two - not even css, probably redundant now
            //Therefore - first two product cards, unless is the 1-3 aspect ratio, in which case it's all of them except the first
            baseSelector = ".aspect-ratio-one-three .flex-item:has(.#CARDTYPE#):not(.aspect-ratio-one-three .flex-item:has(.#CARDTYPE#):first):nth-child(-n+4), .aspect-ratio-one-two .flex-item:has(.#CARDTYPE#):not(.aspect-ratio-one-two .flex-item:has(.#CARDTYPE#):first):nth-child(-n+4), .flex-item:has(.#CARDTYPE#):not(.aspect-ratio-one-three .flex-item:has(.#CARDTYPE#), .aspect-ratio-one-two .flex-item:has(.#CARDTYPE#)):nth-child(-n+4)";
        }
        else {
            baseSelector = ".flex-item:has(.#CARDTYPE#):not(.aspect-ratio-one-three .flex-item:has(.#CARDTYPE#):first, .aspect-ratio-one-two .flex-item:has(.#CARDTYPE#):first)";
        }

        if (isSlick) {
            baseSelector = ".flex-item:has(.#CARDTYPE#):not(.aspect-ratio-one-three .flex-item:has(.#CARDTYPE#):first, .aspect-ratio-one-two .flex-item:has(.#CARDTYPE#):first)";
        }

        var productCardScope = baseSelector.replace(/#CARDTYPE#/g, "sage-product-card");
        var productCardAltScope = baseSelector.replace(/#CARDTYPE#/g, "sage-product-card-alt");

        return [productCardScope, productCardAltScope];
    }

    ProductCardAlignment.prototype.shouldProductCardsResize = function ($el) {
        //$el is the element that was interacted with
        var scopes = getResizeScopesForResolution();
        if (scopes.length === 0) {
            return false;
        }
        else {
            return $el.parents(scopes[0]).length > 0 || $el.parents(scopes[1]).length > 0;
        }
    }

    ProductCardAlignment.prototype.sageProductCardMatchHeight = function () {
        var scopes = getResizeScopesForResolution();
        if (scopes.length === 0) {
            //mobile
            $(".sage-product-card .sage-product-card-header, " +
                ".sage-product-card .sage-product-card-body, " +
                ".sage-product-card-content-alt, " +
                ".sage-product-card-alt .sage-product-card-titles-container, " +
                ".sage-product-card-alt .sage-product-card-section-title-alt, " +
                ".sage-product-card-alt .sage-product-card-section-title-alt .sage-product-card-subtitle, " +
                ".sage-product-card-price-selection, " +
                ".sage-product-card-alt .sage-product-card-price-options-area, " +
                ".sage-product-card-alt .sage-product-card-actions-area, " +
                ".sage-product-card-addon-alt, " +
                ".sage-product-card-alt .body .sage-product-card-features-alt, " +
                ".sage-product-card-alt .header, " +
                ".sage-product-card-alt .body, " +
                ".sage-product-card-alt .footer").matchHeight("remove");
        }
        else {
            var productCardScope = $(scopes[0]);
            var productCardAltScope = $(scopes[1]);

            if (productCardScope && productCardScope.length > 0) {
                productCardScope.find(".sage-product-card-header").matchHeight({ byRow: true });
                productCardScope.find(".sage-product-card-body").matchHeight({ byRow: true });
            }

            if (productCardAltScope && productCardAltScope.length > 0) {
                productCardAltScope.find(".sage-product-card-content-alt").matchHeight({ byRow: true });
                productCardAltScope.find(".sage-product-card-features-alt").matchHeight({ byRow: true });
                productCardAltScope.find(".sage-product-card-titles-container").matchHeight({ byRow: true });
                productCardAltScope.find(".sage-product-card-section-title-alt").matchHeight({ byRow: true });
                productCardAltScope.find(".sage-product-card-title").matchHeight({ byRow: true });
                productCardAltScope.find(".sage-product-card-subtitle").matchHeight({ byRow: true });
                productCardAltScope.find(".sage-product-card-price-selection").matchHeight({ byRow: true });
                productCardAltScope.find(".sage-product-card-price-options-area").matchHeight({ byRow: true });
                productCardAltScope.find(".sage-product-card-actions-area").matchHeight({ byRow: true });
                productCardAltScope.find(".sage-product-card-addon-alt").matchHeight({ byRow: true });
                productCardAltScope.find(".body .sage-product-card-features-alt").matchHeight({ byRow: true });
                productCardAltScope.find(".header").matchHeight({ byRow: true });
                productCardAltScope.find(".body").matchHeight({ byRow: true });
                productCardAltScope.find(".footer").matchHeight({ byRow: true });
            }
        }
    }

    ProductCardAlignment.prototype.setButtonsHeightInProductCards = function (grouped) {
        var that = this;
        $(grouped).each(function (t, sameTop) {
            var arr = new Array();
            var c = -1;

            $(sameTop).each(function (p, pc) {
                c++;
                if (!arr[c]) arr.push([]);

                $(pc).find(".score-button").each(function (b, btn) {
                    arr[c].push(btn);
                });
            });

            that.setHeightForTable(arr, "product-card-inner-height-auto-set-buttons");
        });
    };

    ProductCardAlignment.prototype.setHeightForTable = function (elems, setClass) {
        for (var i = 0; i < elems.length; i++) {
            if (elems[i]) {
                for (var k = 0; k < elems[i].length; k++) {
                    var maxValue = -1;
                    for (var w = 0; w < elems.length; w++) {
                        var height = $(elems[w][k]).height();
                        if (height > maxValue) maxValue = height;
                    }

                    if (maxValue > 0) {
                        $(elems[i][k]).height(maxValue);
                        $(elems[i][k]).addClass(setClass);
                    }
                }
            }
        }
    };

    ProductCardAlignment.prototype.performWrappingOfSimilarElements = function (grouped) {
        var that = this;
        $(grouped).each(function (s, sameTop) {
            $(sameTop).each(function (p, pc) {
                $(pc).each(function (i, item) {
                    var type = "";
                    var storedtype = "x";
                    var arr = new Array();
                    $(item)
                        .children()
                        .each(function (k, elem) {
                            //determine type
                            if ($(elem).hasClass("score-button"))
                                type = "button";
                            else if ($(elem).find(".score-button").length > 0)
                                type = "button";
                            else if ($(elem).is("div[id^='productbuybutton']"))
                                type = "button";
                            else if ($(elem).is("div[id^='producttrybutton']"))
                                type = "button";
                            else if ($(elem).hasClass("score-content-spot"))
                                type = "content";
                            else if ($(elem).hasClass("sage-product-card-price-box"))
                                type = "content";
                            else type = window.getRandomNumber().toString(36); //non specifc

                            if (storedtype === "x") {
                                storedtype = type;
                            }

                            if (type !== storedtype) {
                                //wrap when change type
                                that.wrapArray(arr);
                                arr = [];
                                storedtype = type;
                            }
                            arr.push($(elem));
                        });
                    //wrap the remaining
                    that.wrapArray(arr);
                });
            });
        });
    };

    ProductCardAlignment.prototype.wrapArray = function (arr) {
        //helper to wrap elements comming from an array
        var classgroup = window.getRandomNumber().toString(36);
        while (classgroup.length < 5) {
            classgroup += window.getRandomNumber().toString(36).replace(".","");
        }
        classgroup = classgroup.substring(5);
        $(arr).each(function (x, xitem) {
            $(xitem).addClass(classgroup);
        });
        $("." + classgroup).wrapAll('<div class="product-card-common-element"></div>');
    };

    ProductCardAlignment.prototype.getInsideElements = function (arrProductCards) {
        var he = new Array();
        var c = -1;

        $(arrProductCards).each(function (j, productCardBody) {
            //create array to store list of elements
            c++;
            if (!he[c]) he.push([]);

            $(productCardBody).children().each(function (i, item) {
                he[c].push(item);
            });
        });

        return he;
    };

    ProductCardAlignment.prototype.getProductCardSameTop = function () {
        var arr = new Array();
        var c = -1;
        var selection = ".sage-product-card-body";
        var aprxRate = 200;
        var lastTop = -1000;
        var lastStandard = "";

        $(selection).each(function (i, item) {
            //get if the product card is standard or not.
            //considered not standard if it has one of the classes as below (neutral, enterprise, etc)
            var p = ".sage-product-card";
            var currentStandard =
                $(item)
                    .closest(p)
                    .hasClass("neutral") ||
                    $(item)
                        .closest(p)
                        .hasClass("enterprise") ||
                    $(item)
                        .closest(p)
                        .hasClass("medium-biz") ||
                    $(item)
                        .closest(p)
                        .hasClass("small-biz")
                    ? "not"
                    : "yes";

            var top = $(item).offset().top;
            //will consider different line if the top don`t align and if the type (standard or not) is different.
            if (!(top - aprxRate < lastTop && top + aprxRate > lastTop) || currentStandard !== lastStandard)
            {
                c++;
                lastTop = top;
            }

            //not in the array yet, add
            if (!arr[c]) arr.push([]);

            arr[c].push(item);
            lastStandard = currentStandard;
        });

        return arr;
    };

    ProductCardAlignment.prototype.refreshProductCardHeights = function() {
        //unset
        $(".product-card-inner-height-auto-set").css("height", "");
        $(".product-card-inner-height-auto-set-buttons").css("height", "");
        
        var productCardGroupedSameTop = this.getProductCardSameTop();
        
        if (productCardGroupedSameTop != null && productCardGroupedSameTop.length > 0) {
            //set heights for the inner elements
            this.setHeightsForInnerElements(productCardGroupedSameTop);

            //set height of buttons in the same top
            this.setButtonsHeightInProductCards(productCardGroupedSameTop);
        }
        
        //match height on the containers
        this.sageProductCardMatchHeight();
        
        $("table:not(.clone)").find(".sage-product-card-body").each(function (i, item) {
            if ($("table.clone").find(".sage-product-card-body")[i]) {
                $($("table.clone").find(".sage-product-card-body")[i]).height($(item).height());
            }
        });
    };

    return new ProductCardAlignment();
});
